import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './FirebaseConfig';

import HomeDas from './HomeDas';
import AdminPanel from './AdminPanel';
import RefundData from './RefundData';
import ContactData from './ContactData';

import { toast, ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

// React Icons
import {
  AiFillHome,
  AiOutlineFileText,
  AiOutlineDollar,
  AiOutlineMail,
  AiOutlineLogout,
} from 'react-icons/ai';

const Dashboard = () => {
  const [currentPage, setCurrentPage] = useState('application');
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success('Logged out successfully!');
      navigate('/admin-login');
    } catch (error) {
      toast.error('Error signing out. Please try again.');
      console.error('Logout error:', error);
    }
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Sidebar */}
      <div
        className="d-flex flex-column justify-content-between text-white p-3"
        style={{
          width: '260px',
          height: '100vh', // ✅ Always full height
          position: 'fixed',
          top: 0,
          left: 0,
          backgroundColor: 'darkgray',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.3)',
        }}
      >
        <div>
          <h4 className="text-center fw-bold">Admin Panel</h4>

          {/* Menu items shifted down */}
          <ul
            className="nav flex-column gap-2"
            style={{ marginTop: '60px' }} // 👈 adjust this number (60, 80, 100)
          >
           
            <SidebarButton
              icon={<AiOutlineFileText />}
              label="Application"
              page="application"
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            <SidebarButton
              icon={<AiOutlineDollar />}
              label="Refund"
              page="refund"
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            <SidebarButton
              icon={<AiOutlineMail />}
              label="Contact"
              page="contact"
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </ul>
        </div>

      <div>
  <button
    className="btn btn-danger w-100 mt-4 d-flex align-items-center justify-content-start"
    onClick={handleLogout}
  >
    <AiOutlineLogout className="me-2" /> Logout
  </button>
</div>

      </div>

      {/* Main Content */}
      <div
        className="p-4 overflow-auto bg-light"
        style={{
          marginLeft: '260px', // ✅ leave space for sidebar
          minHeight: '100vh',
        }}
      >
        
        {currentPage === 'application' && <AdminPanel />}
        {currentPage === 'refund' && <RefundData />}
        {currentPage === 'contact' && <ContactData />}
      </div>
    </div>
  );
};

const SidebarButton = ({ icon, label, page, currentPage, setCurrentPage }) => {
  const isActive = currentPage === page;
  return (
    <li className="nav-item">
      <button
        className={`btn w-100 d-flex align-items-center ${
          isActive ? 'btn-primary text-white' : 'btn-light'
        }`}
        onClick={() => setCurrentPage(page)}
        style={{
          transition: 'all 0.3s ease',
          borderRadius: '8px',
          textAlign: 'left',
        }}
      >
        <span className="me-2 fs-5">{icon}</span>
        {label}
      </button>
    </li>
  );
};

export default Dashboard;
